<template>
  <div class="download clearfix">
    <div class="banner">
      <div class="banner-wrapper main"></div>
    </div>
    <div class="blocks main">
      <div v-for="(item, index) in list" class="block" :key="index">
        <div class="block-container clearfix" v-if="item.downloadFileDTOs.length">
          <div class="block-left">
            <p class="title">{{item.name}}</p>
            <p class="info">{{item.description}}</p>
          </div>
          <div class="line"></div>
          <div class="block-right">
              <div class="name-wrapper">
                <span>{{$t('document.documentDownload')}}</span>
              </div>
              <div class="download-part">
                <downloadList :files="item.downloadFileDTOs" :itemId="item.id"/>
              </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import downloadList from '@/components/downloadList.vue'
import { getDownloadCategory, getDownloadFiles } from "@/api"

export default {
  name: 'Download',
  components: {
    downloadList: downloadList
  },
  data() {
    return {
      list: []
    }
  },
  async created() {
    const res = await getDownloadCategory()
    const ids = res.data.data.list.filter(cat => cat.display).map(cat => cat.id);

    const { data } = await getDownloadFiles(ids)
    this.list = data.data;
  }
}
</script>
<style lang="scss" scoped>
.banner {
  height: 540px;
  background-color: #3794e0;

  .banner-wrapper {
    height: 100%;
    background: url("../assets/images/banner.png") no-repeat center center;
    background-size: 700px 360px;
  }
}

.blocks {
  $blockLeftWidth: 70%;
  padding: 10px 0 30px 0;
  .block {
    display: block;
    margin-top: 20px;
    background-color: #FAFBFC;
    .block-container {
      max-width: 1634px;
      margin: 0 auto;
      min-height: 168px;
      position: relative;
    }
  }
  .line {
    display: block;
    position: absolute;
    top: 0;
    left: 70%;
    width: 1px;
    height: 100%;
    background-color: rgba(0,0,0,0.12);
  }
  .block-left {
    display: block;
    float: left;
    box-sizing: border-box;
    width: 70%;
    padding: 25px 65px;
    .title {
      font-size: 22px;
      color: rgba(0,0,0,0.70);
      line-height: 32px;
      // font-weight: bold;
    }
    .info {
      margin-top: 15px;
      line-height: 20px;
      font-size: 14px;
      color: rgba(0,0,0,0.70);
      word-wrap: break-word;
    }
  }
  .block-right {
    display: block;
    box-sizing: border-box;
    width: 30%;
    overflow: hidden;
    padding: 25px 30px 15px 30px;

    .name-wrapper {
      // padding: 3px 0;
      // font-weight: bold;
      font-size: 18px;
      color: rgba(0,0,0,0.70);
      line-height: 26px;
    }

    .download-part {
      margin-top: 16px;
      // line-height: 30px;
      font-size: 14px;
    }
  }
}

@media only screen and  (max-width: 768px) {
  .blocks {
    padding: 10px 0 30px;
    .block {
      display: block;
      margin-top: 20px;
      background-color: #f9fafd;
      position: relative;
      .block-container {
        .line {
          position: static;
          height: .01rem;
          width: auto;
          margin: 0 .5rem;
        }
      }
      .block-left {
        width: 100%;
        float: none !important;
        padding: 40px 35px 20px 35px;
        .info {
          padding: 0 15px;
          font-size: 14px;
        }
      }
      .block-right {
        display: block;
        width: 100%;
        padding: 20px 50px 30px 50px;
      }
    }
  }
}

@media only screen and  (max-width: 375px) {
  .blocks {
    .block {
      .block-container {
        .line {
          margin: 0 20px;
        }
      }
      .block-left {
        padding: 20px 15px;
        .info {
          padding: 0 5px;
        }
      }
      .block-right {
        padding: 20px;
      }
    }
  }
}
@media only screen and  (max-width: 320px) {
  .blocks {
    .block {
      .block-container {
        .line {
          margin: 0 10px;
        }
      }
      .block-left {
        padding: 15px 10px;
        .info {
          padding: 0;
        }
      }
      .block-right {
        padding: 10px;
      }
    }
  }
}
</style>

<style lang="scss">
// ????
.download-table {
  border-collapse: collapse;
  th, td {
    padding: 5px 10px;
    text-align: left;
    vertical-align: middle;
  }
  th {
    border: 1px solid #e1e6f3;
    background-color: #f4f5f9;
    color: #3e1e6f;
  }
  tr {
    border: 1px solid #e1e6f3;
  }
}
</style>
